import React, { useState } from 'react'
import { getIssues, Issues } from 'utils/IssuesUtil';
import { useAppContext } from 'hooks/useAppContext';
import Grid from './Grid'
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import {
  Redirect,
} from "react-router-dom";

const OpenIssuesGrid = ({customFilter}) => {
  const columns = Issues.columns
  const { selectedProject } = useAppContext(); //Getting the App Context
  // const title = "Open Issues"
  const title = "Issues"
  const getFormPath = () => import('components/Shared/SkeletonForm')
  const enable = { "delete": false, "edit": false }
  const [details, setDetails] = useState(false)
  const [issueID, setIssueID] = useState("")
  const [issue, setIssue] = useState({})

  const issuesDetails = (data) => {
    setIssueID(data.IssueId)
    setIssue(data)
    setDetails(true)
  };

  const selection = { "display": true, "callback": issuesDetails, "btnText": "Details", "status": "Open" };

  return (
    <div style={{ padding: '10px' }}>
      {
        details && <Redirect to={{ pathname: `/projects/${selectedProject}/Issues/${issueID}`, state: { issue: issue } }} />
      }
      {
        selectedProject ?
          <Grid 
            columns={columns}
            title={title}
            getRecords={getIssues}
            selectedProject={selectedProject}
            component="Issues"
            formPath={getFormPath}
            enable={enable}
            selection={selection}
            customFilter={customFilter}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
          /> : <SkeletonGrid title={title} />
      }
  
    </div>
  )
}

export default OpenIssuesGrid